// extracted by mini-css-extract-plugin
export default {"base":"DialogConfirmationModRemove_base__JmSIO","content":"DialogConfirmationModRemove_content__fF+CS","button":"DialogConfirmationModRemove_button__wsWGQ"};